import { Outlet, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import DynamicNavbar from "../components/DynamicOrgNavbar";
import Footer from "../components/Footer";
import { useDomain } from "@useDomain";
import api from "@api";

function PublicLayout() {
  const location = useLocation();
  const {
    slug,
    domain,
    organization: userForDomain,
    loadingDomain,
  } = useDomain();
  const [currentPage, setCurrentPage] = useState(null);
  const [navbarReady, setNavbarReady] = useState(false);
  const [pageReady, setPageReady] = useState(false);
  const hostname = window.location.hostname;
  const isSaaSRootDomain = ["sportinghip.com", "www.sportinghip.com", "localhost"].includes(hostname);
  const isSaaSRootLanding = isSaaSRootDomain && location.pathname === "/";
  const isSpecialYouthPage = /\/youth\/jccoc$/.test(location.pathname);

  const hideNavbar =
    isSaaSRootLanding ||
    isSpecialYouthPage;

  const hideFooter = isSpecialYouthPage;

  const isDirectoryLikePage =
    (isSaaSRootDomain && location.pathname === "/") ||
    location.pathname === "/pp" ||
    location.pathname === "/about" ||
    location.pathname === "/privacy" ||
    location.pathname === "/terms" ||
    location.pathname === "/login" ||
    location.pathname === "/register" ||
    location.pathname === "/verify-email" ||
    location.pathname === "/forgot-password" ||
    location.pathname === "/reset-password" ||
    location.pathname === "/audience" ||
    location.pathname === "/sport" ||
    location.pathname === "/state" ||
    location.pathname === "/county" ||
    location.pathname === "/wall" ||
    location.pathname === "/field" ||
    location.pathname.startsWith("/messages") ||
    location.pathname.startsWith("/profile") ||
    location.pathname === "/challenges" ||
    location.pathname.startsWith("/state/") ||
    location.pathname.startsWith("/county/") ||
    location.pathname.startsWith("/sport/") ||
    location.pathname.startsWith("/audience/") ||
    location.pathname.startsWith("/leagues/") ||
    location.pathname.startsWith("/demo") ||
    location.pathname.startsWith("/playersbasketball") ||
    location.pathname.startsWith("/playersteambasketball") ||
    location.pathname.startsWith("/playersgamebasketball") ||
    location.pathname.startsWith("/playerstennis") ||
    location.pathname.startsWith("/playersteamtennis");

  const theme = userForDomain?.theme || "light";

  useEffect(() => {
    let alive = true;

    const loadCurrentPage = async () => {
      try {
        if (!userForDomain) {
          setCurrentPage(null);
          return;
        }

        let path = location.pathname.replace(/^\/+|\/+$/g, "");

        if (slug && path.startsWith(`${slug}/`)) {
          path = path.replace(`${slug}/`, "");
        } else if (slug && path === slug) {
          path = "";
        }

        if (!path) {
          setCurrentPage(null);
          return;
        }

        const systemPagePaths = ["standings", "schedule", "players", "leaderboard"];

        const isSystemPagePath =
          systemPagePaths.includes(path) ||
          path.startsWith("players/") ||
          path.startsWith("teams/") ||
          path.startsWith("games/") ||
          path.startsWith("standings/") ||
          path.startsWith("schedule/") ||
          path.startsWith("leaderboard/");

        if (isSystemPagePath) {
          setCurrentPage(null);
          return;
        }

        const res = await api.get("/api/onboarding/organizations/public/page", {
          params: {
            slug: slug || undefined,
            domain: domain || undefined,
            organizationId: userForDomain?.id || undefined,
            path,
          },
        });

        if (!alive) return;
        setCurrentPage(res.data?.page || null);
      } catch (error) {
        if (!alive) return;
        setCurrentPage(null);
      }
    };

    loadCurrentPage();

    return () => {
      alive = false;
    };
  }, [location.pathname, slug, domain, userForDomain?.id]);

  useEffect(() => {
    setNavbarReady(false);
  }, [slug, domain, userForDomain?.id]);

  useEffect(() => {
    setPageReady(false);

    const frame = requestAnimationFrame(() => {
      setPageReady(true);
    });

    return () => cancelAnimationFrame(frame);
  }, [location.pathname]);
  
  const siteReady =
    isDirectoryLikePage ||
    hideNavbar ||
    (navbarReady && pageReady);




  if (!isDirectoryLikePage && loadingDomain) {
    return null;
  }

  if (!isDirectoryLikePage && !userForDomain) {
    return null;
  }

  return (
    <div
      className={
        isDirectoryLikePage
          ? "public-static-shell"
          : `public-org-shell public-theme-${userForDomain?.theme_mode || "light"}`
      }
      style={{
        visibility: siteReady ? "visible" : "hidden",
      }}
    >
      {userForDomain && !hideNavbar && (
        <DynamicNavbar
          page={currentPage}
          onReady={() => setNavbarReady(true)}
        />
      )}

      <Outlet context={{ setPageReady }} />

      {userForDomain && !hideFooter && <Footer userForDomain={userForDomain} />}
    </div>
  );
}

export default PublicLayout;